import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import { DateTimePicker } from "react-widgets";
// import { AutocompleteNhaCungCap } from "./AutocompleteNhaCungCap";
import Autocomplete from "react-autocomplete";
import { Popover, OverlayTrigger, Alert } from "react-bootstrap";
import { AutocompleteSanPham } from "./AutocompleteSanPham";
import { convertToNumber } from "utils/currencyFormat";
import numeral from "numeral";
import CongThucSanPhamApi from "../../../service/CongThucSanPham/CongThucSanPhamApi";
import DatHangApi from "../../../service/DatHang/DatHangApi";
import iconCustomer from "../../../Resources/ImagesNew/Group2196.png";
import moment from "moment";
import DanhMucNewApi from "../../../service/DanhMucNewApi";

export const ThongTinHangBan = ({
    isShowGiaBan,
    isNhapCongThucNhanhTTK,
    dataBanHang,
    setDataBanHang,
    categoryNow,
    setCategoryNow,
    value,
    setValue,
    StoreID,
    setStoreID,
    objDataStore,
    roleGiaVon,
    roleBanCuon,
    roleMaMc,
    disEditDonGia,
    disEditAll,
    IsFocusTenSanPham,
    setFocusTenSanPham,
    onSubmit,
    IsFocusKho,
    setFocusKho,
    GoiPhanMem,
    HienthiAutotrukhogiacong,
    isNhapThueGTGT,
    tatCanhBaoLuongTon,
}) => {
    const inputIsNXCuon = useRef();
    const inputCongThuc = useRef();
    const inputKieuGiaCong = useRef();
    const inputSLDonViBan = useRef();
    const inputKho = useRef();
    if (IsFocusKho) {
        inputKho.current.focus();
        setFocusKho(false);
    }
    console.log("GoiPhanMem123", GoiPhanMem);
    const [isFocusChonSanPham, setFocusChonSanPham] = useState(false);
    useEffect(() => {
        if (
            isFocusChonSanPham &&
            typeof inputCongThuc.current !== "undefined" &&
            inputCongThuc.current !== null
        ) {
            inputCongThuc.current.focus();
            setFocusChonSanPham(false);
            return;
        } else if (
            isFocusChonSanPham &&
            typeof inputKieuGiaCong.current !== "undefined" &&
            inputKieuGiaCong.current !== null
        ) {
            inputKieuGiaCong.current.focus();
            setFocusChonSanPham(false);
            return;
        } else if (
            isFocusChonSanPham &&
            typeof inputSLDonViBan.current !== "undefined" &&
            inputSLDonViBan.current !== null
        ) {
            inputSLDonViBan.current.focus();
            setFocusChonSanPham(false);
        }
    }, [isFocusChonSanPham]);
    const dispatch = useDispatch();
    const [ketQuaCongThuc, setKetQuaCongThuc] = useState(0);
    //lấy mặc định kho đầu tiên

    const [getCategoryID, setGetCategoryID] = useState(0);


    const onChangeGiaCong = () => (evt) => {
        const cate = { ...categoryNow };
        var obj = cate.Options.find(
            (e) => e.OptionID == convertToNumber(evt.target.value)
        );
        if (evt.target.value != "0") {
            cate.RateForSale = obj.RateForSale;
            cate.OptionID = obj.OptionID;
            cate.DonVi = obj.DonVi;
            cate.ImportPrice = cate.ImportPriceOld;
            cate.ExportPrice = obj.Price;
            cate.Price = obj.Price;
            cate.GiaGoc = cate.Price;
        } else {
            cate.RateForSale = 1;
            cate.OptionID = 0;
            cate.DonVi = "";
            cate.ImportPrice = cate.ImportPriceOld;
            cate.ExportPrice = cate.Price;
            cate.Price = cate.PriceOld;
            cate.GiaGoc = cate.Price;
        }
        cate.GiaTB = obj.GiaTB;
        cate.GiaMax = obj.GiaMax;
        cate.GiaMin = obj.GiaMin;
        cate.GiaNew = obj.GiaNew;
        setCategoryNow(cate);
    };

    const onChangeCheck = (field, e) => updateCheck(field, e);
    const updateCheck = (field, e) => {
        const thongtin = { ...categoryNow };
        thongtin[field] = e.target.checked;

        setCategoryNow(thongtin);
    };

    const onChangeCheck1 = (field, e) => updateCheck1(field, e);
    const updateCheck1 = (field, e) => {
        const thongtin = { ...categoryNow };
        thongtin[field] = e.target.checked;
        thongtin.SLDonViBan = thongtin.SoCayTrenBo.toString();
        thongtin.ShowQuantityNew = true;
        thongtin.OptionID = 0;

        if (thongtin.Attributes.length > 0) {
            var attr = thongtin.LstDonViNhap.find(
                (e) => e.AttributeID === thongtin.IdDonViXuatView
            );
            if (attr.AttributeID != thongtin.IdDonViXuatView) {
            }
            const newData = thongtin.Attributes.map((row, i) => {
                let item = { ...row };
                if (row.AttributeID == thongtin.IdDonViXuatView) {
                    item.Values = numeral(
                        (row.RatioDifferentView / row.RatioMainView) * thongtin.SLDonViBan
                    ).format("0.[0000]");
                    item.RatioDifferentNew = 0;
                } else {
                    item.Values = numeral(
                        (row.RatioDifferentView / row.RatioMainView) * thongtin.SLDonViBan
                    ).format("0.[0000]");
                    item.RatioDifferentNew = 0;
                }
                return item;
            });
            thongtin.Attributes = [...newData];
        }
        setCategoryNow(thongtin);
    };

    //Thuộc tính khác
    const onChangeThuocTinh = (field, e) =>
        updateThuocTinhCategoryNow(field, parseInt(e.target.value));
    const updateThuocTinhCategoryNow = (field, IdDonViXuatView) => {
        const cate = { ...categoryNow };
        debugger;
        var attrMain = categoryNow.LstDonViNhap.find(
            (e) => e.AttributeID === cate.IdDonViXuat
        );

        var attrOld = cate.LstDonViNhap.find(
            (e) => e.AttributeID === cate.IdDonViXuatView
        );
        cate.IdDonViXuatView = IdDonViXuatView;
        var attr = cate.LstDonViNhap.find(
            (e) => e.AttributeID === cate.IdDonViXuatView
        );

        if (attr != null) {
            let index = 0;
            cate.Attributes.map((item, i) => {
                if (item.AttributeID == cate.IdDonViXuatView) {
                    index = i;
                }
            });

            cate.Attributes.splice(index, 1);
            cate.Attributes.push(attrOld);
            let lstAttrNew = cate.Attributes.map((item, i) => {
                if (item.AttributeID === cate.IdDonViXuatView) {
                    item.RatioDifferentView = attr.RatioMain;
                    item.RatioMainView = attr.RatioDifferent;
                } else {
                    cate.Price = (
                        (cate.ExportPrice / attr.RatioDifferent) *
                        attr.RatioMain
                    ).toFixed();

                    cate.GiaGoc = cate.Price;
                    item.RatioDifferentNew = 0;
                    item.RatioMainView =
                        (attr.RatioDifferent / attr.RatioMain) * item.RatioMain;
                    item.RatioDifferentView = item.RatioDifferent;
                }
                return item;
            });
            cate.Attributes = lstAttrNew;



            if (cate.Attributes.length > 0) {
                var attr = cate.LstDonViNhap.find(
                    (e) => e.AttributeID === cate.IdDonViXuatView
                );
                if (attr.AttributeID != cate.IdDonViXuatView) {
                    // value =
                }
                const newData = cate.Attributes.map((row, i) => {
                    let item = { ...row };
                    if (row.AttributeID == cate.IdDonViXuatView) {
                        item.Values = numeral(
                            (row.RatioDifferentView / row.RatioMainView) * cate.SLDonViBan
                        ).format("0.[0000]");
                        item.RatioDifferentNew = 0;
                    } else {
                        item.Values = numeral(
                            (row.RatioDifferentView / row.RatioMainView) * cate.SLDonViBan
                        ).format("0.[0000]");
                        item.RatioDifferentNew = 0;
                    }
                    return item;
                });
                cate.Attributes = [...newData];
            }

            setCategoryNow(cate);
        }
    };

    const onChangeSLBan = (e) => updateSLDonViBan("SLDonViBan", e);
    //Thuộc tính khác
    // số lượng nhập thường
    //Số lượng nhập
    const updateSLDonViBan = (field, e) => {
        debugger
        const cate = { ...categoryNow };
        const value = e.target.validity.valid ? e.target.value : cate[field];
        cate[field] = value;
        if (cate.Attributes.length > 0) {
            var attr = cate.LstDonViNhap.find(
                (e) => e.AttributeID === cate.IdDonViXuatView
            );
            if (attr.AttributeID != cate.IdDonViXuatView) {
                // value =
            }
            const newData = cate.Attributes.map((row, i) => {
                let item = { ...row };
                if (row.AttributeID == cate.IdDonViXuatView) {
                    item.Values = numeral(
                        (row.RatioDifferentView / row.RatioMainView) * cate[field]
                    ).format("0.[0000]");
                    item.RatioDifferentNew = 0;
                } else {
                    item.Values = numeral(
                        (row.RatioDifferentView / row.RatioMainView) * cate[field]
                    ).format("0.[0000]");
                    item.RatioDifferentNew = 0;
                }
                return item;
            });
            cate.Attributes = [...newData];
            if (isShowGiaBan) {
                // Thay đổi giá xuất của sản phẩm theo số lượng bán
                DanhMucNewApi
                    .getGiaSanPhamTheoSoLuong({
                        CategoryId: cate.CategoryID,
                        SoLuong: value == "" ? 0 : value,
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            cate.GiaGoc = response.data;
                            cate.Price = response.data;
                        }

                        setCategoryNow(cate);
                    });
            } else {
                setCategoryNow(cate);
            }
        }
    };

    //End

    //Số lượng bán
    const onChangeSLBan1 = (e) => updateSLDonViBan1("SLDonViBan", e);
    const updateSLDonViBan1 = (field, e) => {
        const cate = { ...categoryNow };

        // const value = e.target.value;
        const value = e.target.validity.valid ? e.target.value : cate[field];

        if (typeof value === "undefined") {
            cate.SLDonViBan = "";
        } else {
            cate.SLDonViBan = value;
        }

        if (isShowGiaBan) {
            // Thay đổi giá xuất của sản phẩm theo số lượng bán
            DanhMucNewApi
                .getGiaSanPhamTheoSoLuong({
                    CategoryId: cate.CategoryID,
                    SoLuong: value == "" ? 0 : value,
                })
                .then((response) => {
                    if (response.status == 200) {
                        cate.GiaGoc = response.data;
                        cate.Price = response.data;
                    }

                    setCategoryNow(cate);
                });
        } else {
            setCategoryNow(cate);
        }
    };

    const onChangeSLBan2 = (e) => updateSLDonViBan2("SLDonViBan", e);
    const updateSLDonViBan2 = (field, e) => {
        const cate = { ...categoryNow };

        // const value = e.target.value;
        const value = e.target.validity.valid ? e.target.value : cate[field];

        if (typeof value === "undefined") {
            cate.SLDonViBan = "";
        } else {
            // const regx = /^[*.+()]*[0-9][*.+()0-9]*$/;
            const regx = /^[0-9 ()+*.]+$/;
            if (e.target.value === "" || regx.test(e.target.value)) {
                cate.SLDonViBan = e.target.value;
            }
        }

        if (isShowGiaBan) {
            // Thay đổi giá xuất của sản phẩm theo số lượng bán
            DanhMucNewApi
                .getGiaSanPhamTheoSoLuong({
                    CategoryId: cate.CategoryID,
                    SoLuong: value == "" ? 0 : value,
                })
                .then((response) => {
                    if (response.status == 200) {
                        cate.GiaGoc = response.data;
                        cate.Price = response.data;
                    }

                    setCategoryNow(cate);
                });
        } else {
            setCategoryNow(cate);
        }
    };
    //Số lượng
    const onChangeQuantity = (e) => updateCategoryNow1("Quantity", e);
    const updateCategoryNow1 = (field, e) => {
        const cate = { ...categoryNow };
        var value = e.target.validity.valid ? e.target.value : cate[field];
        cate[field] = value;
        if (isShowGiaBan && field == "Quantity") {
            // Thay đổi giá xuất của sản phẩm theo số lượng bán
            DanhMucNewApi
                .getGiaSanPhamTheoSoLuong({
                    CategoryId: cate.CategoryID,
                    SoLuong: value == "" ? 0 : value,
                })
                .then((response) => {
                    if (response.status == 200) {
                        cate.GiaGoc = response.data;
                        cate.Price = response.data;
                    }
                    setCategoryNow(cate);
                });
        } else {
            setCategoryNow(cate);
        }
    };

    //Tỉ trọng
    const updatePriceSaleTiTrong = (field, e) => {
        const cate = { ...categoryNow };
        const value = e.target.validity.valid ? e.target.value : cate[field];
        cate[field] = value;
        cate.Price = (convertToNumber(cate[field]) * cate.TiTrong).toFixed(0);
        cate.ExportPrice = cate.Price;
        cate.GiaGoc = cate.Price;
        setCategoryNow(cate);
    };
    const onChangePriceSaleTiTrong = (e) =>
        updatePriceSaleTiTrong("PriceSaleTiTrong", e);

    //Giá
    const onChangeGTGT = (field, e) => {
        const cate = { ...categoryNow };
        const value = e.target.validity.valid ? e.target.value : cate[field];
        cate[field] = value;
        setCategoryNow(cate);
    };
    const onChangeThueGTGT = (field, e) => {
        const cate = { ...categoryNow };
        const value = e.target.validity.valid ? e.target.value : cate[field];
        cate[field] = value;
        setCategoryNow(cate);
    };
    const onChangeExportPrice = (e) => updateCategoryNow("GiaGoc", e);
    const updateCategoryNow = (field, e) => {
        const cate = { ...categoryNow };
        const value = e.target.validity.valid ? e.target.value : cate[field];

        cate[field] = convertToNumber(value);
        cate.ExportPrice = convertToNumber(value);
        cate.PriceSaleTiTrong = (
            convertToNumber(cate[field]) / cate.TiTrong
        ).toFixed(0);
        if (cate["IsVND"]) {
            cate.ChietKhau = "";
            cate.Price = Number.parseFloat(
                numeral(cate.GiaGoc).format("0.[0000]") -
                numeral(cate.ChietKhau).format("0.[0000]")
            );
        } else if (cate["IsPercent"]) {
            cate.ChietKhau = "";
            cate.Price =
                Number.parseFloat(numeral(cate.GiaGoc).format("0.[0000]")) -
                (Number.parseFloat(numeral(cate.GiaGoc).format("0.[0000]")) *
                    Number.parseFloat(numeral(cate.ChietKhau).format("0.[0000]"))) /
                100;
        }
        setCategoryNow(cate);
    };

    const onChangeMoney = (e) => updateChangeMoney("IsVND", e);
    const updateChangeMoney = (field, e) => {
        const cate = { ...categoryNow };
        cate["IsPercent"] = false;
        cate["LoaiChietKhau"] = 1;
        cate.ChietKhau = "";
        cate[field] = true;

        cate.Price = cate.GiaGoc;

        setCategoryNow(cate);
    };

    const onChangePercent = (e) => updateChangePercent("IsPercent", e);
    const updateChangePercent = (field, e) => {
        const cate = { ...categoryNow };
        cate["IsVND"] = false;
        cate["LoaiChietKhau"] = 2;
        cate.ChietKhau = "";
        cate.Price = cate.GiaGoc;
        cate[field] = true;
        setCategoryNow(cate);
    };

    const onChangeValueAttr = (e, index) => updateValueAttr(e, index);
    const updateValueAttr = (e, index) => {
        const cate = { ...categoryNow };
        var newAttr = cate.Attributes.map((Attribute, i) => {
            if (i == index) {
                e.target.value = e.target.value.replace(/,/g, "").replace(/-/g, "");
                const value = e.target.validity.valid
                    ? e.target.value
                    : Attribute.Values;
                Attribute.Values = value;
                if (value) {
                    Attribute.RatioDifferentNew = value / cate.SLDonViBan;
                } else {
                    Attribute.RatioDifferentNew = 0;
                }
            }
            return Attribute;
        });
        cate.Attributes = newAttr;
        setCategoryNow(cate);
    };

    const onChangeCheckAttr = (e, index) =>
        updateCheckAttr(e.target.checked, index);
    const updateCheckAttr = (value, index) => {
        const cate = { ...categoryNow };
        var newAttr = cate.Attributes.map((Attribute, i) => {
            Attribute.isCheck = false;
            if (i == index && value) {
                Attribute.isCheck = true;
            }
            return Attribute;
        });
        setCategoryNow(cate);
    };

    //Tính công thức sản phẩm
    const onChangeCongThuc = (index, e) => {
        const cate1 = { ...categoryNow };
        let check = true;
        cate1.CongThucSanPham.KyHieu.map((item, index) => {
            if (
                item.GiaTri === 0 ||
                item.GiaTri === "" ||
                item.GiaTri === "0" ||
                item.GiaTri.trim() === ""
            ) {
                if (check == true) check = false;
            }
        });

        if (check === true) {
            CongThucSanPhamApi.getKetQuaCongThuc(categoryNow.CongThucSanPham).then(
                (response) => {
                    const cate = { ...categoryNow };
                    let ketQuaCongThuc = response.data;
                    if (ketQuaCongThuc == null || ketQuaCongThuc == 0) {
                        cate.SLDonViBan = "";
                        ketQuaCongThuc = 0;
                    } else {
                        cate.SLDonViBan = ketQuaCongThuc.toString();
                    }
                    setKetQuaCongThuc(ketQuaCongThuc);
                    if (cate.Attributes.length > 0) {
                        var attr = cate.LstDonViNhap.find(
                            (e) => e.AttributeID === cate.IdDonViXuatView
                        );
                        if (attr.AttributeID != cate.IdDonViXuatView) {
                            // value =
                        }
                        const newData = cate.Attributes.map((row, i) => {
                            let item = { ...row };
                            if (row.AttributeID == cate.IdDonViXuatView) {
                                item.Values = numeral(
                                    (row.RatioDifferentView / row.RatioMainView) * ketQuaCongThuc
                                ).format("0.[0000]");
                            } else {
                                item.Values = numeral(
                                    (row.RatioDifferentView / row.RatioMainView) * ketQuaCongThuc
                                ).format("0.[0000]");
                            }
                            return item;
                        });
                        cate.Attributes = [...newData];
                    }
                    setCategoryNow(cate);
                }
            );
        } else {
            const cate = { ...categoryNow };
            cate.SLDonViBan = "";
            setKetQuaCongThuc(0);
            if (cate.Attributes.length > 0) {
                var attr = cate.LstDonViNhap.find(
                    (e) => e.AttributeID === cate.IdDonViXuatView
                );
                if (attr.AttributeID != cate.IdDonViXuatView) {
                    // value =
                }
                const newData = cate.Attributes.map((row, i) => {
                    let item = { ...row };
                    if (row.AttributeID == cate.IdDonViXuatView) {
                        item.Values = numeral(
                            (row.RatioDifferentView / row.RatioMainView) * 0
                        ).format("0.[0000]");
                    } else {
                        item.Values = numeral(
                            (row.RatioDifferentView / row.RatioMainView) * 0
                        ).format("0.[0000]");
                    }
                    return item;
                });
                cate.Attributes = [...newData];
            }

            setCategoryNow(cate);
        }
    };

    const onChangeGiaTriCongThuc = (index, e) => {
        const cate = { ...categoryNow };
        let _giatri = e.target.validity.valid
            ? e.target.value
            : cate.CongThucSanPham.KyHieu[index].GiaTri;
        cate.CongThucSanPham.KyHieu[index].GiaTri = _giatri;
        setCategoryNow(cate);
    };

    const updateTextValue1 = (field) => (e) => {
        setCategoryNow({
            ...categoryNow,
            [field]: e.target.value,
        });
    };
    const onChangeDate = (field) => (evt) => {
        setCategoryNow({
            ...categoryNow,
            [field]: evt,
        });
    };

    console.log(categoryNow, "categoryNow.LstDonViNhapcategoryNow.LstDonViNhap");
    const [checkSPBanTTK, setCheckSPBanTTK] = useState(false);

    const handleKeyDownEnter = (context) => (e) => {
        console.log(context, "1111111");
        console.log(e, "a1111111");
        console.log(e.keyCode, "21111111");
        if (e.keyCode === 13) {
            onSubmit();
        }
    };
    return (
        <>
            <div className="col-lg-4">
                <h2 class="title-detail-new">
                    <img src={iconCustomer} alt="#" />
                    Thông tin sản phẩm
                </h2>
            </div>

            <div class="col-md-12 col-lg-12 ">
                <div class="form-group  align-centerNew ">
                    <div class="form-new-input-left">
                        <label class="label-control text-left-main" for="eventRegInput2">
                            Tên sản phẩm
                        </label>
                        <div class="input-group">
                            <AutocompleteSanPham
                                setCategoryNow={setCategoryNow}
                                value={value}
                                setValue={setValue}
                                StoreID={StoreID}
                                dataBanHang={dataBanHang}
                                setCheckSPBanTTK={setCheckSPBanTTK}
                                setGetCategoryID={setGetCategoryID}
                                disEditAll={disEditAll}
                                IsFocusTenSanPham={IsFocusTenSanPham}
                                setFocusTenSanPham={setFocusTenSanPham}
                                setFocusChonSanPham={setFocusChonSanPham}
                                BranchID={dataBanHang.BranchID}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {typeof categoryNow.CategoryID != "undefined" &&
                categoryNow.isNXCuon === true &&
                roleMaMc === true && (
                    <div class="col-md-4">
                        <div class="form-group  align-centerNew ">
                            <div class="form-new-input-left">
                                <label
                                    class="label-control text-left-main"
                                    for="eventRegInput2"
                                >
                                    Ghi chú MAMC
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    pattern="[0-9.+]*"
                                    value={categoryNow.NoteMaMc}
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                )}

            {typeof categoryNow.CategoryID != "undefined" &&
                categoryNow.CongThucSanPham.CongThucID > 0 && (
                    <>
                        <div class="col-md-12" style={{ padding: "0px" }}>
                            {categoryNow.CongThucSanPham.KyHieu.map((item, index) => {
                                return (
                                    <>
                                        <div class="col-md-4">
                                            <div class="form-group  align-centerNew ">
                                                <div class="form-new-input-left">
                                                    <label
                                                        class="label-control text-left-main"
                                                        for="eventRegInput2"
                                                    // style={{ width: "40px" }}
                                                    >
                                                        {item.TenKyHieu}

                                                        <OverlayTrigger
                                                            placement="top"
                                                            trigger={["hover"]}
                                                            overlay={
                                                                <Popover id="popover-basic">
                                                                    <Popover.Title as="h3"></Popover.Title>
                                                                    <Popover.Content>
                                                                        <span className="textPopver">
                                                                            {item.Mota}
                                                                        </span>
                                                                    </Popover.Content>
                                                                </Popover>
                                                            }
                                                        >
                                                            <i
                                                                class="mdi mdi-comment-question-outline"
                                                                style={{
                                                                    color: "#0056b8",
                                                                    position: "absolute",
                                                                    top: "0px",
                                                                }}
                                                            ></i>
                                                        </OverlayTrigger>
                                                    </label>
                                                    {index === 0 ? (
                                                        <input
                                                            ref={inputCongThuc}
                                                            type="text"
                                                            class="form-control"
                                                            pattern="[0-9.]*"
                                                            style={{ width: "100%" }}
                                                            value={item.GiaTri === 0 ? "" : item.GiaTri}
                                                            onBlur={(e) => onChangeCongThuc(index, e)}
                                                            onChange={(e) => onChangeGiaTriCongThuc(index, e)}
                                                            onKeyDown={handleKeyDownEnter()}
                                                            placeholder="0"
                                                        />
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            pattern="[0-9.]*"
                                                            style={{ width: "100%" }}
                                                            value={item.GiaTri === 0 ? "" : item.GiaTri}
                                                            onBlur={(e) => onChangeCongThuc(index, e)}
                                                            onChange={(e) => onChangeGiaTriCongThuc(index, e)}
                                                            onKeyDown={handleKeyDownEnter()}
                                                            placeholder="0"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                            <div class="col-md-4 ">
                                <div class="form-group iconPriceEdit">
                                    {categoryNow.CongThucSanPham.CongThuc}
                                    {" = "}
                                    {ketQuaCongThuc > 0 ? ketQuaCongThuc : "?"}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            {/* Gia công */}
            {typeof categoryNow.CategoryID != "undefined" &&
                categoryNow.Options.length > 0 && (
                    <div class="col-md-4">
                        <div class="form-group  align-centerNew ">
                            <div class="form-new-input-left">
                                <label
                                    class="label-control text-left-main"
                                    for="eventRegInput2"
                                >
                                    Kiểu gia công
                                </label>
                                {categoryNow.Options.length > 0 && (
                                    <select
                                        ref={inputKieuGiaCong}
                                        class="form-control selectCss"
                                        onChange={onChangeGiaCong()}
                                        disabled={categoryNow.isNXCuon}
                                        value={categoryNow.OptionID}
                                    >
                                        {categoryNow.Options.map((Option, index) => {
                                            const { Name, OptionID } = Option;
                                            return <option value={OptionID}>{Name}</option>;
                                        })}
                                    </select>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            {/* Thuộc tính khác Attr */}
            {typeof categoryNow.CategoryID != "undefined" &&
                categoryNow.Attributes.length > 0 &&
                (!isNhapCongThucNhanhTTK ||
                    (isNhapCongThucNhanhTTK &&
                        categoryNow.TenDonViXuat !== null &&
                        categoryNow.ShowQuantity == false)) && (
                    <div class="col-md-4">
                        <div class="form-group  align-centerNew ">
                            <div class="form-new-input-left">
                                <label
                                    class="label-control"
                                    style={{ paddingLeft: "0px", marginLeft: "0px" }}
                                >
                                    {dataBanHang.configThuocTinhKhac === "1" ? (
                                        checkSPBanTTK === true ? (
                                            <select
                                                style={{ width: "100%" }}
                                                class="form-control"
                                                value={categoryNow.IdDonViXuatView}
                                                onChange={(e) =>
                                                    onChangeThuocTinh("IdDonViXuatView", e)
                                                }
                                                disabled={checkSPBanTTK}
                                            >
                                                {categoryNow.LstDonViNhap.map((attribute, index) => {
                                                    const { Display, AttributeID } = attribute;
                                                    return <option value={AttributeID}>{Display}</option>;
                                                })}
                                            </select>
                                        ) : (
                                            <select
                                                style={{ width: "100%" }}
                                                class="form-control"
                                                value={categoryNow.IdDonViXuatView}
                                                onChange={(e) =>
                                                    onChangeThuocTinh("IdDonViXuatView", e)
                                                }
                                                disabled={categoryNow.CongThucSanPham.CongThucID > 0}
                                            >
                                                {categoryNow.LstDonViNhap.map((attribute, index) => {
                                                    const { Display, AttributeID } = attribute;
                                                    return <option value={AttributeID}>{Display}</option>;
                                                })}
                                            </select>
                                        )
                                    ) : (
                                        <select
                                            style={{ width: "100%" }}
                                            class="form-control"
                                            disabled={true}
                                            value={categoryNow.IdDonViXuatView}
                                            onChange={(e) => onChangeThuocTinh("IdDonViXuatView", e)}
                                        >
                                            {categoryNow.LstDonViNhap.map((attribute, index) => {
                                                const { Display, AttributeID } = attribute;
                                                return <option value={AttributeID}>{Display}</option>;
                                            })}
                                        </select>
                                    )}
                                    {/* gia công */}
                                </label>

                                <input
                                    ref={inputSLDonViBan}
                                    type="text"
                                    class="form-control"
                                    pattern="[0-9.]*"
                                    value={categoryNow.SLDonViBan}
                                    onChange={onChangeSLBan}
                                    placeholder="0"
                                    disabled={categoryNow.CongThucSanPham.CongThucID > 0}
                                    onKeyDown={handleKeyDownEnter()}
                                />
                            </div>
                        </div>
                    </div>
                )}
            {typeof categoryNow.CategoryID != "undefined" &&
                categoryNow.Attributes.length > 0 &&
                categoryNow.TenDonViXuat !== null &&
                categoryNow.ShowQuantity == true &&
                isNhapCongThucNhanhTTK && (
                    <div class="col-md-4">
                        <div class="form-group  align-centerNew ">
                            <div class="form-new-input-left">
                                <label
                                    class="label-control"
                                    style={{ paddingLeft: "0px", marginLeft: "0px" }}
                                >
                                    {dataBanHang.configThuocTinhKhac === "1" ? (
                                        checkSPBanTTK === true ? (
                                            <select
                                                style={{ width: "100%" }}
                                                class="form-control"
                                                value={categoryNow.IdDonViXuatView}
                                                onChange={(e) =>
                                                    onChangeThuocTinh("IdDonViXuatView", e)
                                                }
                                                disabled={checkSPBanTTK}
                                            >
                                                {categoryNow.LstDonViNhap.map((attribute, index) => {
                                                    const { Display, AttributeID } = attribute;
                                                    return <option value={AttributeID}>{Display}</option>;
                                                })}
                                            </select>
                                        ) : (
                                            <select
                                                style={{ width: "100%" }}
                                                class="form-control"
                                                value={categoryNow.IdDonViXuatView}
                                                onChange={(e) =>
                                                    onChangeThuocTinh("IdDonViXuatView", e)
                                                }
                                                disabled={categoryNow.CongThucSanPham.CongThucID > 0}
                                            >
                                                {categoryNow.LstDonViNhap.map((attribute, index) => {
                                                    const { Display, AttributeID } = attribute;
                                                    return <option value={AttributeID}>{Display}</option>;
                                                })}
                                            </select>
                                        )
                                    ) : (
                                        <select
                                            style={{ width: "100%" }}
                                            class="form-control"
                                            disabled={true}
                                            value={categoryNow.IdDonViXuatView}
                                            onChange={(e) => onChangeThuocTinh("IdDonViXuatView", e)}
                                        >
                                            {categoryNow.LstDonViNhap.map((attribute, index) => {
                                                const { Display, AttributeID } = attribute;
                                                return <option value={AttributeID}>{Display}</option>;
                                            })}
                                        </select>
                                    )}
                                    {/* gia công */}
                                </label>

                                <input
                                    ref={inputSLDonViBan}
                                    type="text"
                                    class="form-control"
                                    pattern="[0-9.+*()]*"
                                    value={categoryNow.SLDonViBan}
                                    onChange={onChangeSLBan}
                                    placeholder="0"
                                    disabled={categoryNow.CongThucSanPham.CongThucID > 0}
                                    onKeyDown={handleKeyDownEnter()}
                                />
                            </div>
                        </div>
                    </div>
                )}

            {typeof categoryNow.CategoryID != "undefined" &&
                categoryNow.Attributes.length == 0 &&
                categoryNow.TenDonViXuat !== null &&
                categoryNow.ShowQuantity == false && (
                    <div class="col-md-4">
                        <div class="form-group  align-centerNew ">
                            <div class="form-new-input-left">
                                <label
                                    class="label-control text-left-main"
                                    for="eventRegInput2"
                                >
                                    {categoryNow.TenDonViXuat}
                                </label>
                                <input
                                    ref={inputSLDonViBan}
                                    type="text"
                                    class="form-control"
                                    pattern="[0-9.]*"
                                    value={categoryNow.SLDonViBan}
                                    onChange={onChangeSLBan1}
                                    disabled={categoryNow.CongThucSanPham.CongThucID > 0}
                                    placeholder="0"
                                    onKeyDown={handleKeyDownEnter()}
                                />
                            </div>
                        </div>
                    </div>
                )}

            {typeof categoryNow.CategoryID != "undefined" &&
                categoryNow.Attributes.length == 0 &&
                categoryNow.TenDonViXuat !== null &&
                categoryNow.ShowQuantity == true && (
                    <div class="col-md-4">
                        <div class="form-group  align-centerNew ">
                            <div class="form-new-input-left">
                                <label
                                    class="label-control text-left-main"
                                    for="eventRegInput2"
                                >
                                    {categoryNow.TenDonViXuat}
                                </label>
                                <input
                                    ref={inputSLDonViBan}
                                    type="text"
                                    class="form-control"
                                    pattern="[0-9.+*()]*"
                                    value={categoryNow.SLDonViBan}
                                    onChange={onChangeSLBan2}
                                    disabled={categoryNow.CongThucSanPham.CongThucID > 0}
                                    placeholder="0"
                                    onKeyDown={handleKeyDownEnter()}
                                />
                            </div>
                        </div>
                    </div>
                )}


            {typeof categoryNow != "undefined" &&
                categoryNow.ShowQuantity == true &&
                categoryNow.TenDonViXuat != null &&
                categoryNow.CongThucSanPham.CongThucID > 0 && (
                    <div class="col-md-4">
                        <div class="form-group  align-centerNew ">
                            <div class="form-new-input-left">
                                <label
                                    class="label-control text-left-main"
                                    for="eventRegInput2"
                                >
                                    Số lượng
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    pattern="[0-9]*"
                                    value={categoryNow.Quantity}
                                    onChange={onChangeQuantity}
                                    onKeyDown={handleKeyDownEnter()}
                                />
                            </div>
                        </div>
                    </div>
                )}
            {typeof categoryNow != "undefined" &&
                categoryNow.ShowQuantity == true &&
                categoryNow.TenDonViXuat != null &&
                categoryNow.CongThucSanPham.CongThucID == 0 &&
                categoryNow.Attributes.length > 0 && (
                    <div class="col-md-4">
                        <div class="form-group  align-centerNew ">
                            <div class="form-new-input-left">
                                <label
                                    class="label-control text-left-main"
                                    for="eventRegInput2"
                                >
                                    Số lượng
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    pattern="[0-9]*"
                                    value={categoryNow.Quantity}
                                    onChange={onChangeQuantity}
                                    onKeyDown={handleKeyDownEnter()}
                                />
                            </div>
                        </div>
                    </div>
                )}

            {categoryNow.IsShowTiTrong &&
                categoryNow.AllowTiTrong &&
                dataBanHang.ConfigTiTrong === true && (
                    <>
                        <div class="col-md-4">
                            <div class="form-group  align-centerNew ">
                                <div class="form-new-input-left">
                                    <label
                                        class="label-control text-left-main"
                                        for="eventRegInput2"
                                    >
                                        Tỉ trọng
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control text-right"
                                        pattern="[0-9,.]*"
                                        value={categoryNow.TiTrong}
                                        disabled="true"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4" style={{ display: "none" }}>
                            <div class="form-group  align-centerNew ">
                                <div class="form-new-input-left">
                                    <label
                                        class="label-control text-left-main"
                                        for="eventRegInput2"
                                    >
                                        Giá theo tỉ trọng
                                    </label>
                                    <NumberFormat
                                        onKeyDown={handleKeyDownEnter()}
                                        class="form-control text-right"
                                        pattern="[0-9,.]*"
                                        thousandSeparator={true}
                                        value={
                                            categoryNow.PriceSaleTiTrong === 0
                                                ? ""
                                                : categoryNow.PriceSaleTiTrong
                                        }
                                        onChange={onChangePriceSaleTiTrong}
                                        placeholder="0"

                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            {/* {categoryNow.IsShowTiTrong && categoryNow.AllowTiTrong && (
        
      )} */}
            {typeof categoryNow.CategoryID != "undefined" &&
                dataBanHang.isShowThueGTGT === true && (
                    <div class="col-md-4" style={{ display: "none" }}>
                        {isNhapThueGTGT === true ? (
                            <div class="form-group  align-centerNew ">
                                <div class="form-new-input-left">
                                    <label
                                        class="label-control text-left-main"
                                        for="eventRegInput2"
                                    >
                                        Thuế suất GTGT
                                    </label>
                                    {/* <NumberFormat
                    onKeyDown={handleKeyDownEnter()}
                    class="form-control text-right"
                    pattern="[0-9,.]*"
                    thousandSeparator={true}
                    value={
                      categoryNow.ThueGTGT === 0 ? "" : categoryNow.ThueGTGT
                    }
                    onChange={(e) => onChangeThueGTGT("ThueGTGT", e)}
                    placeholder="0"
                    disabled={disEditAll}
                  /> */}

                                    <input
                                        type="text"
                                        class="form-control text-right"
                                        pattern="[0-9.]*"
                                        value={
                                            categoryNow.ThueGTGT === 0 ? "" : categoryNow.ThueGTGT
                                        }
                                        // onChange={(e) => onChangeThueGTGT("ThueGTGT", e)}
                                        placeholder="0"
                                        disabled={true}
                                    //   onKeyDown={handleKeyDownEnter()}
                                    />

                                    <span s>%</span>
                                </div>
                            </div>
                        ) : (
                            <div class="form-group  align-centerNew " style={{ display: "none" }}>
                                <div class="form-new-input-left">
                                    <label
                                        class="label-control text-left-main"
                                        for="eventRegInput2"
                                    >
                                        Thuế suất GTGT
                                    </label>
                                    <select
                                        class="form-control "
                                        value={categoryNow.ThueGTGT}
                                        //onChange={(e) => onChangeGTGT("ThueGTGT", e)}
                                        disabled={true}
                                    >
                                        <option value="0">0 %</option>
                                        <option value="5">5 %</option>
                                        <option value="8">8 %</option>
                                        <option value="10">10 %</option>
                                    </select>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            {typeof categoryNow.CategoryID != "undefined" && (
                <div class="col-md-4" style={{ display: "none" }}>
                    <div class="form-group  align-centerNew ">
                        <div class="form-new-input-left">
                            <label class="label-control text-left-main" for="eventRegInput2">
                                Đơn giá
                            </label>
                            <NumberFormat
                                onKeyDown={handleKeyDownEnter()}
                                class="form-control text-right"
                                placeholder="0"
                                pattern="[0-9,.]*"
                                value={
                                    categoryNow.GiaGoc === 0
                                        ? ""
                                        : Number.parseFloat(
                                            numeral(categoryNow.GiaGoc).format("0.[0000]")
                                        ).toFixed(0)
                                }
                                thousandSeparator={true}
                                // onChange={onChangeExportPrice}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            )}

            {typeof categoryNow.CategoryID != "undefined" &&
                dataBanHang.configChietKhau === "1" && (
                    <div class="col-md-4" style={{ display: "none" }}>
                        <div class="form-group  align-centerNew ">
                            <div class="form-new-input-left">
                                <label
                                    class="label-control text-left-main"
                                    for="eventRegInput2"
                                >
                                    Giá bán
                                </label>
                                <NumberFormat
                                    class="form-control text-right"
                                    placeholder="0"
                                    pattern="[0-9,.]*"
                                    value={Number.parseFloat(
                                        numeral(categoryNow.Price).format("0.[0000]")
                                    ).toFixed(0)}
                                    thousandSeparator={true}
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                )}

            {/*Thuộc tính */}
            {typeof categoryNow.Attributes != "undefined" &&
                categoryNow.Attributes.length > 0 &&
                categoryNow.Attributes.map((Attribute, index) => {
                    const { Display, Values } = Attribute;
                    if (typeof Attribute.RatioDifferentView === "undefined") {
                        Attribute.RatioDifferentView = Attribute.RatioDifferent;
                        Attribute.RatioMainView = Attribute.RatioMain;
                    }
                    let Tile =
                        Attribute.RatioDifferentView + "/" + Attribute.RatioMainView;
                    return (
                        <div class="col-md-12">
                            <div class="row align-centerbh">
                                {dataBanHang.configThuocTinhKhac === "1" ? (
                                    <>
                                        <div class="col-md-4">
                                            <div class="form-group  align-centerNew ">
                                                <div class="form-new-input-left">
                                                    <label
                                                        class="label-control text-left-main"
                                                        for="eventRegInput2"
                                                    >
                                                        {Display}
                                                    </label>
                                                    <input
                                                        class="form-control text-right"
                                                        type="text"
                                                        value={Tile}
                                                        disabled="true"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group  align-centerNew ">
                                                <NumberFormat
                                                    onKeyDown={handleKeyDownEnter()}
                                                    class="form-control text-right"
                                                    pattern="[0-9.]*"
                                                    value={Values === 0 ? "" : Values}
                                                    thousandSeparator={true}
                                                    onChange={(e) => onChangeValueAttr(e, index)}
                                                    placeholder="0"
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div class="col-md-4">
                                            <div class="form-group  align-centerNew ">
                                                <div class="form-new-input-left">
                                                    <label
                                                        class="label-control text-left-main"
                                                        for="eventRegInput2"
                                                    >
                                                        {Display}
                                                    </label>
                                                    <input
                                                        class="form-control text-right"
                                                        type="text"
                                                        value={Tile}
                                                        disabled="true"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group  align-centerNew ">
                                                <NumberFormat
                                                    onKeyDown={handleKeyDownEnter()}
                                                    class="form-control text-right"
                                                    pattern="[0-9.]*"
                                                    value={Values === 0 ? "" : Values}
                                                    thousandSeparator={true}
                                                    onChange={(e) => onChangeValueAttr(e, index)}
                                                    placeholder="0"
                                                />
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="form-group  align-centerNew ">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    name="exampleCheck1"
                                                    id="ContentPlaceHolder1_txtTTK"
                                                    checked={
                                                        Attribute.IsBanTTK === true
                                                            ? true
                                                            : Attribute.isCheck
                                                    }
                                                    value={Attribute.isCheck}
                                                    disabled={Attribute.IsBanTTK}
                                                    onChange={(e) => onChangeCheckAttr(e, index)}
                                                    onKeyDown={handleKeyDownEnter()}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    );
                })}
            <div class="col-md-12">
                <div class="form-group  align-centerNew ">
                    <div class="form-new-input-left textArea-w">
                        <label class="label-control text-left-main" for="eventRegInput2">
                            Ghi chú
                        </label>
                        <textarea
                            class="form-control"
                            id="idGhiChu"
                            rows="1"
                            onChange={updateTextValue1("Note")}
                            value={categoryNow.Note}
                            disabled={disEditAll}
                        // onKeyDown={handleKeyDownEnter()}
                        ></textarea>
                    </div>
                </div>
            </div>
        </>
    );
};
